export default __webpack_public_path__ + "static/media/hdb-thumbnail-completed.de1503f0.svg";